var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-text-field", {
        key: _vm.fieldRestore,
        ref: "file",
        staticClass: "body-2",
        attrs: {
          "show-size": "",
          "truncate-length": "22",
          "prepend-icon": "$file",
          label: "Adjunta trazabilidad de la falla",
          rules: [_vm.rules.required()],
          "persistent-hint": "",
          readonly: ""
        },
        on: {
          click: function() {
            _vm.fieldRestore++
            _vm.wasOpen = true
            _vm.tempFile = _vm.file
            _vm.$refs.modal.openModal()
          }
        },
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _c(
        "base-modal",
        {
          ref: "modal",
          attrs: {
            title: "Adjunta trazabilidad de la falla",
            icon: "mdi-attachment",
            "max-with": "600"
          }
        },
        [
          _c(
            "v-container",
            { staticClass: "pa-2" },
            [
              _c("p", [
                _vm._v(
                  " Realiza una captura de pantalla donde se evidencie la trazabilidad de la falla. Para ello: "
                )
              ]),
              _c(
                "v-timeline",
                { staticClass: "pt-1", attrs: { dense: "" } },
                [
                  _c(
                    "v-timeline-item",
                    { attrs: { icon: "mdi-numeric-1", color: "green" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "elevation-2" },
                        [
                          _c("v-card-text", [
                            _vm._v(
                              " Accede a la consola de comandos (CMD), encontrada en el Menú Inicio – Ejecutar – escribe CMD y pulsa enter. "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-timeline-item",
                    { attrs: { icon: "mdi-numeric-2", color: "green" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "elevation-2" },
                        [
                          _c("v-card-text", [
                            _vm._v(
                              " Una vez dentro de la consola, escribe tracert seguido del destino al que quieras llegar, bien sea un dominio, o una IP. "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-timeline-item",
                    { attrs: { icon: "mdi-numeric-3", color: "green" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "elevation-2" },
                        [
                          _c("v-card-text", [
                            _vm._v(
                              " Pulsa enter y aparecerán los resultados del tracert al destino. Ej.: "
                            ),
                            _c("kbd", [_vm._v("C:\\Users∖om>ping 8.8.8.8")]),
                            _vm._v(" o "),
                            _c("kbd", [
                              _vm._v("C\\:Users∖om>tracert -d 8.8.8.8")
                            ]),
                            _vm._v(" etc. ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-timeline-item",
                    { attrs: { icon: "mdi-numeric-4", color: "green" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "elevation-2" },
                        [
                          _c("v-card-text", [
                            _vm._v(" Realiza un "),
                            _c("i", [_vm._v("printscreen")]),
                            _vm._v(
                              " de pantalla donde está la información y guarda el archivo en tu equipo. "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-form",
                { ref: "form", attrs: { "lazy-validation": "" } },
                [
                  _c("v-file-input", {
                    staticClass: "mr-2 mb-2",
                    attrs: {
                      accept: _vm.availableFiles,
                      "show-size": "",
                      "truncate-length": "22",
                      counter: "",
                      "counter-size-string": "",
                      label:
                        "Adjunta aquí el archivo para su registro en el portal",
                      rules: [
                        _vm.rules.required(),
                        function() {
                          return _vm.validFile || "Tipo de archivo inválido"
                        }
                      ]
                    },
                    model: {
                      value: _vm.tempFile,
                      callback: function($$v) {
                        _vm.tempFile = $$v
                      },
                      expression: "tempFile"
                    }
                  }),
                  _c(
                    "v-row",
                    { attrs: { dense: "", align: "center" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "green",
                                dark: "",
                                block: "",
                                outlined: ""
                              },
                              on: {
                                click: function() {
                                  return _vm.$refs.modal.closeModal()
                                }
                              }
                            },
                            [_vm._v("Cancelar")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "green", dark: "", block: "" },
                              on: {
                                click: function() {
                                  if (_vm.$refs.form.validate()) {
                                    _vm.file = _vm.tempFile
                                    _vm.$refs.modal.closeModal()
                                  }
                                }
                              }
                            },
                            [_vm._v("Aceptar")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.dragActive
        ? _c("attachment-zone", {
            attrs: { "selected-file": _vm.tempFile },
            on: {
              "update:selectedFile": function($event) {
                _vm.tempFile = $event
              },
              "update:selected-file": function($event) {
                _vm.tempFile = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }